import dayjs from 'dayjs';

import type { Modeling } from '@/type';

export const calculateTrainingTime = (
  modeling: Modeling,
): {
  hours: number;
  minutes: number;
  seconds: number;
} => {
  if (!modeling.trainStartTime || !modeling.trainEndTime)
    return {
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

  const startTime = dayjs(modeling.trainStartTime);
  const endTime = dayjs(modeling.trainEndTime);
  const diffInMs = endTime.diff(startTime);

  const hours = Math.floor(diffInMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000);

  return {
    hours,
    minutes,
    seconds,
  };
};
